import { AlertCircleIcon } from "lucide-react";

const EstablishmentConsumptionEstimativeNote = () => {
  return (
    <div className="flex items-center gap-3">
      <AlertCircleIcon size={42} strokeWidth={1.5} color="var(--warning)" />

      <p className="text-sm">
        O Estabelecimento não será informado dos totais consumidos, apenas da estimativas de consumo informada.
      </p>
    </div>
  );
};

export default EstablishmentConsumptionEstimativeNote;
